import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: "highlight",
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  chars = { a: "[aá]", e: "[eé]", i: "[ií]", o: "[oó]", u: "[uú]", ñ: "[nñ]]" };

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }
    // console.log(args); //cast
    // console.log(value); //TPDP
    // Match in a case insensitive maneer
    const args1 = args.replace(/[aeiouñ]/gi, (m) => this.chars[m]);

    const re = new RegExp(args1, "gi");
    const match = value.match(re);

    // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    const replacedValue = value.replace(re, "<mark>" + match[0] + "</mark>");

    return replacedValue;
  }
}
